import { render, staticRenderFns } from "./candidate-preference-list-skeleton.vue?vue&type=template&id=43e647f2&scoped=true&"
import script from "./candidate-preference-list-skeleton.vue?vue&type=script&lang=js&"
export * from "./candidate-preference-list-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./candidate-preference-list-skeleton.vue?vue&type=style&index=0&id=43e647f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e647f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
